<template>
	<transition name="fade">
		<div v-if="isVisible" class="email-popup-overlay" @click.self="closePopup">
			<div class="email-popup-modal">
				<div class="popup-image-col">
					<img :src="imageSrc" alt="Join Mailing List" />
				</div>
				<div class="popup-content-col">
					<button class="close-btn" @click="closePopup">×</button>

					<div class="content-wrapper">
						<h2>Worth Staying For.</h2>
						<p class="subtitle">New collections, studio stories, and the occasional surprise…</p>

						<form @submit.prevent="submitEmail" class="email-form">
							<div class="input-group">
								<label for="email" class="input-label"></label>
								<input type="text" id="email" v-model="email" class="email-input"
									placeholder="Your Email Address" :disabled="submitting" required />
							</div>

							<div class="submit-wrapper">
								<button type="submit" class="submit-btn" :disabled="submitting">
									{{ submitting ? 'Submitting...' : '[Submit]' }}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	import founderImg from '@/assets/about/email.png'
	import {
		subscribeEmail
	} from '@/api/content'
	import {
		showMessage
	} from '@/config/message'

	export default {
		name: 'EmailPopup',
		props: {
			visible: {
				type: Boolean,
				default: false
			},
			autoShowDelay: {
				type: Number,
				default: 15000 // 15秒后自动显示（设为0可禁用自动显示）
			}
		},
		data() {
			return {
				isVisible: false,
				email: '',
				imageSrc: founderImg,
				timer: null,
				submitting: false
			}
		},
		watch: {
			visible(val) {
				console.log('EmailPopup visible prop:', val);
				if (val) {
					this.openPopup();
				} else {
					// 关键：关闭时也要清除定时器，防止后台继续计时
					if (this.timer) {
						clearTimeout(this.timer);
						this.timer = null;
					}
					this.isVisible = false;
				}
			}
		},
		mounted() {
			// 自动显示逻辑（仅在未手动打开时触发）
			if (this.autoShowDelay > 0 && !this.visible && !this.isVisible) {
				this.timer = setTimeout(() => {
					// 再次确认弹窗未被手动打开
					if (!this.isVisible && !this.visible) {
						this.isVisible = true;
					}
				}, this.autoShowDelay);
			}
		},
		beforeDestroy() {
			if (this.timer) clearTimeout(this.timer);
		},
		methods: {
			// openPopup() {
			//     this.isVisible = true;
			//     if (this.timer) {
			//         clearTimeout(this.timer);
			//         this.timer = null;
			//     }
			// },
			// closePopup() {
			//     this.isVisible = false;
			//     this.$emit('update:visible', false); // 通知父组件同步 .sync
			//     this.$emit('close'); // 保留原有事件
			// },
			openPopup() {
				console.log('openPopup called, isVisible before:', this.isVisible);
				if (this.isVisible) return; // 已打开则直接返回
				this.isVisible = true;
				if (this.timer) {
					clearTimeout(this.timer);
					this.timer = null;
				}
			},
			closePopup() {

				if (this.timer) {
					clearTimeout(this.timer);
					this.timer = null;
				}
				this.isVisible = false;
				this.$emit('update:visible', false);
				this.$emit('close');
			},
			async submitEmail() {
				if (this.submitting) return;

				if (!this.email || this.email.trim() === '') {
					showMessage('Please enter your email address.', 'error');
					return;
				}

				const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
				if (!emailRegex.test(this.email)) {
					showMessage('Please enter a valid email address.', 'error');
					return;
				}

				this.submitting = true;
				// try {
				// 	const result = await subscribeEmail(this.email);

				// 	if (result === true) {
				// 		showMessage('Thank you for joining our mailing list!', 'success');
				// 		this.closePopup();
				// 		this.email = '';
				// 	} else {
				// 		showMessage('Subscription failed. Please try again later.', 'error');
				// 	}
				// } catch (error) {
				// 	 debugger
				// 	console.error('Subscription error:', error);
				// 	showMessage('An error occurred. Please try again.', 'error');
				// } finally {
				// 	this.submitting = false;
				// }
				try {
					const response = await subscribeEmail(this.email); // 现在 response 是完整的 ReturnModel 对象

					console.log(response)
					if (response && response.retCode === 1) {
						showMessage('Thank you for joining our mailing list!', 'success');
						this.closePopup();
						this.email = '';
					} else {
						showMessage(response.retMsg || 'Subscription failed', 'error');
						this.closePopup();
					}
				} catch (error) {
					console.error('Subscription error:', error);
					showMessage('An error occurred. Please try again.', 'error');
				} finally {
					this.submitting = false;
				}
			}
		}
	}
</script>

<style scoped>
	.email-popup-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 20001;
		/* Highest z-index to overlay everything including UserInfo and Menu */
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 20rem;
	}

	.email-popup-modal {
		background-color: #fff;
		width: 923rem;
		max-width: 100%;
		height: 583rem;
		/* Fixed height for desktop look */
		display: flex;
		box-shadow: 0 10rem 40rem rgba(0, 0, 0, 0.2);
		overflow: hidden;
		border: 1rem solid #000;
	}

	.popup-image-col {
		width: 47%;
		height: 100%;
		background-color: #f5f5f5;
		position: relative;
	}

	.popup-image-col img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}

	.popup-content-col {
		width: 53%;
		height: 100%;
		padding: 60rem 50rem;
		position: relative;
		display: flex;
		flex-direction: column;
		justify-content: center;
		text-align: center;
	}

	.close-btn {
		position: absolute;
		top: 11rem;
		right: 11rem;
		background: none;
		border: none;
		font-size: 28rem;
		cursor: pointer;
		line-height: 1;
		color: #000;
		padding: 5rem;
	}

	.content-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
		font-family: 'Apercu', sans-serif !important;
		font-weight: 500 !important;
		margin-top: -56rem;
	}

	h2 {
		font-size: 28rem;
		font-weight: 600;
		margin-bottom: 63rem;
		color: #000;
		letter-spacing: 0.5rem;
	}

	.subtitle {
		font-size: 16rem;
		color: #999;
		margin-bottom: 60rem;
		max-width: 280rem;
		line-height: 1.5;
		font-weight: 500;
	}

	.email-form {
		width: 100%;
		max-width: 375rem;
		position: absolute;
		bottom: 56rem;
	}

	.input-group {
		margin-bottom: 30rem;
		text-align: left;
	}

	.input-label {
		display: block;
		font-size: 16rem;
		font-weight: 500;
		color: #000;
		margin-bottom: 5rem;
	}

	.email-input {
		width: 100%;
		border: none;
		border-bottom: 2rem solid #000;
		padding: 8rem 0;
		font-size: 16rem;
		outline: none;
		font-family: 'Apercu', sans-serif !important;
	}

	.email-input::placeholder {
		color: #000000;
		font-family: 'Apercu', sans-serif !important;
	}

	.email-input:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}

	.submit-wrapper {
		text-align: center;
	}

	.submit-btn {
		background: none;
		border: none;
		font-size: 14rem;
		font-weight: 600;
		cursor: pointer;
		color: #000;
		padding: 10rem 20rem;
	}

	.submit-btn:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}

	/* 新增淡入淡出动画 */
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.3s ease;
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}

	/* Responsive adjustments */
	@media (max-width: 768px) {
		.email-popup-overlay {
			display: none;
		}

		.email-popup-modal {
			flex-direction: column;
			height: auto;
			max-height: 90vh;
			width: 100%;
			border-radius: 4rem;
		}

		.popup-image-col {
			width: 100%;
			height: 200rem;
		}

		.popup-content-col {
			width: 100%;
			padding: 40rem 30rem;
		}

		h2 {
			font-size: 24rem;
			margin-bottom: 15rem;
		}

		.subtitle {
			margin-bottom: 30rem;
		}
	}
</style>